import React from 'react';
import type { ViewProps } from 'react-native';
import { useBreakpointHelpers } from '@sweetgreen/garnish';

import type { Credit } from '../../graphql/types';
import { CreditMenu } from './CreditMenu/CreditMenu';
import { CreditOverview } from './CreditOverview/CreditOverview';

export const CreditSection = (
  props: CreditSectionProps,
): React.ReactElement => {
  const { isMobile } = useBreakpointHelpers();

  return isMobile ? <CreditMenu {...props} /> : <CreditOverview {...props} />;
};

export type CreditSectionProps = {
  readonly creditAmount: number;
  readonly creditDetails: readonly Credit[];
  readonly promoCode: string;
  readonly hasPromoCodeError: boolean;
  readonly isLoadingCredits: boolean;
  readonly isSubmittingPromoCode: boolean;
  readonly onPressAvailableCredit: () => void;
  readonly onPressAddPromoCode: () => void;
  readonly setPromoCode: (code: string) => void;
  readonly onPressApplyPromoCode: (code: string) => void;
} & ViewProps;
